(() => {
  const key = 'binahad_engagement_session_v1';
  let session;
  try { session = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch {}
  session = Object.assign({ elapsed: 0, shown: false, dismissed: false, checkout: false }, session || {});
  const save = () => { try { sessionStorage.setItem(key, JSON.stringify(session)); } catch {} };
  let lastTick = performance.now();
  let visible = !document.hidden;
  let purchaseUntil = 0;
  let cartHasItems = Number(document.querySelector('[data-bnh-cart-state]')?.dataset.itemCount || 0) > 0;
  let promoCleanup;
  const sampleTime = () => {
    const now = performance.now();
    if (visible) session.elapsed += Math.max(0, now - lastTick);
    lastTick = now;
    visible = !document.hidden;
    save();
  };
  document.addEventListener('visibilitychange', sampleTime);
  window.addEventListener('pagehide', sampleTime);
  window.addEventListener('pageshow', () => { lastTick = performance.now(); visible = !document.hidden; });

  const otherOverlay = () => document.body.classList.contains('menu-open') || document.body.classList.contains('dialog-open') || !!document.querySelector('dialog[open]:not(.bnh-promo), [aria-modal="true"]:not([aria-hidden="true"]), .cart-drawer.is-open, .drawer.is-open, [data-drawer].is-open, .shopify-pc__banner, details[data-bnh-mega][open]');
  const checkoutControl = element => element?.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"], .shopify-payment-button');
  const guardPurchase = event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (checkoutControl(target) || (event.type === 'submit' && target.matches('form[action*="/cart"]') && event.submitter?.name === 'checkout')) {
      session.checkout = true;
      save();
      document.querySelector('[data-bnh-teaser]')?.setAttribute('hidden', '');
    }
    if (target.closest('[data-product-form], [data-sticky-button], form[action*="/cart/add"]')) purchaseUntil = Date.now() + 10000;
  };
  document.addEventListener('pointerdown', guardPurchase, true);
  document.addEventListener('click', guardPurchase, true);
  document.addEventListener('submit', guardPurchase, true);

  const initProductLinks = scope => {
    scope.querySelectorAll('[data-bnh-product-whatsapp]').forEach(link => {
      if (link.dataset.bnhReady) return;
      link.dataset.bnhReady = 'true';
      const root = link.closest('[data-product-root]');
      const form = link.closest('form');
      if (!root || !form) return;
      if (root.nextElementSibling?.matches('[data-sticky-atc]')) return;
      const update = () => {
        const id = form.querySelector('[name="id"]')?.value || '';
        const quantity = Math.max(1, parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10) || 1);
        const options = [...root.querySelectorAll('[data-option-group]')].map(group => {
          const input = group.querySelector('input:checked, select');
          const name = group.querySelector('legend')?.childNodes[0]?.textContent?.trim() || '';
          return input?.value ? `${name}: ${input.value}` : '';
        }).filter(Boolean);
        const url = new URL(link.dataset.url, location.origin);
        if (id) url.searchParams.set('variant', id);
        const text = [link.dataset.greeting, link.dataset.title, ...options, `${link.dataset.quantityLabel}: ${quantity}`, url.href].join('\n');
        link.href = `https://wa.me/${link.dataset.number.replace(/\D/g, '')}?text=${encodeURIComponent(text)}`;
      };
      root.addEventListener('change', () => queueMicrotask(update));
      root.addEventListener('input', () => queueMicrotask(update));
      link.addEventListener('click', update);
      link.addEventListener('contextmenu', update);
      update();
    });
  };

  const initPromo = () => {
    promoCleanup?.();
    const root = document.querySelector('[data-bnh-promo]');
    if (!root) return;
    const dialog = root.querySelector('dialog');
    const teaser = root.querySelector('[data-bnh-teaser]');
    if (!dialog || !teaser || typeof dialog.showModal !== 'function') return;
    const controller = new AbortController();
    const listen = (target, type, callback, extra = {}) => target.addEventListener(type, callback, { ...extra, signal: controller.signal });
    const design = root.dataset.designMode === 'true';
    const delay = Number(root.dataset.delay || 10) * 1000;
    const scrollPercent = Number(root.dataset.scroll || 20);
    let previousOverflow;
    let previousFocus;
    let engaged = false;
    let timer;
    const revealTeaser = () => { teaser.hidden = session.checkout || design; teaser.setAttribute('aria-expanded', 'false'); };
    const finishClose = () => {
      if (previousOverflow !== undefined) document.body.style.overflow = previousOverflow;
      previousOverflow = undefined;
      if (!design) { session.dismissed = true; save(); }
      revealTeaser();
      const focus = previousFocus?.isConnected ? previousFocus : teaser;
      if (!document.hidden && !focus.hidden) focus.focus({ preventScroll: true });
    };
    const close = () => { if (dialog.open) dialog.close(); };
    const open = manual => {
      if (dialog.open || document.hidden || session.checkout) return false;
      if (otherOverlay()) return false;
      if (!manual && !design) {
        if (root.dataset.auto !== 'true' || cartHasItems || session.shown || session.dismissed || Date.now() < purchaseUntil) return false;
        if (document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return false;
      }
      previousFocus = document.activeElement;
      try { dialog.showModal(); } catch { return false; }
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      teaser.hidden = true;
      teaser.setAttribute('aria-expanded', 'true');
      dialog.querySelector('h2')?.focus({ preventScroll: true });
      if (!design) { session.shown = true; save(); }
      clearInterval(timer);
      return true;
    };
    listen(teaser, 'click', () => open(true));
    root.querySelectorAll('[data-bnh-close]').forEach(button => listen(button, 'click', close));
    listen(dialog, 'close', finishClose);
    listen(dialog, 'cancel', event => { event.preventDefault(); close(); });
    let backdropDown = false;
    const outside = event => { const box = dialog.getBoundingClientRect(); return event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom; };
    listen(dialog, 'pointerdown', event => { backdropDown = event.target === dialog && outside(event); });
    listen(dialog, 'click', event => { if (backdropDown && event.target === dialog && outside(event)) close(); backdropDown = false; });
    const autoEligible = root.dataset.auto === 'true' && !session.shown && !session.dismissed && !session.checkout;
    if (autoEligible) {
      listen(document, 'pointermove', event => { if (event.clientY > 50) engaged = true; }, { passive: true });
      listen(document, 'mouseout', event => {
        if (root.dataset.exit !== 'true' || !engaged || event.relatedTarget !== null || event.clientY > 0) return;
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) open(false);
      });
      const onScroll = () => {
        if (session.shown || session.dismissed || session.checkout) return;
        const distance = document.documentElement.scrollHeight - window.innerHeight;
        if (distance > 0 && Math.max(window.scrollY, 0) / distance * 100 >= scrollPercent) open(false);
      };
      listen(window, 'scroll', onScroll, { passive: true });
    }
    const copy = root.querySelector('[data-bnh-copy]');
    if (copy) listen(copy, 'click', async () => {
      if (copy.disabled) return;
      const code = copy.dataset.code;
      const label = copy.querySelector('[data-bnh-copy-label]');
      const status = root.querySelector('[data-bnh-copy-status]');
      const original = label.textContent;
      let copied = false;
      copy.disabled = true;
      label.textContent = copy.dataset.applying;
      try { await navigator.clipboard.writeText(code); copied = true; } catch {
        const field = document.createElement('textarea');
        field.value = code;
        field.setAttribute('readonly', '');
        field.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
        dialog.appendChild(field);
        field.select();
        try { copied = document.execCommand('copy'); } catch {}
        field.remove();
        copy.focus({ preventScroll: true });
      }
      const apiRoot = window.Shopify?.routes?.root || '/';
      try {
        const cartResponse = await fetch(`${apiRoot}cart.js`, { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('cart');
        const cart = await cartResponse.json();
        const codes = [...new Set([...(cart.discount_codes || []).map(item => item.code), code])];
        const result = await fetch(`${apiRoot}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: codes.join(',') }) });
        if (!result.ok) throw new Error('discount');
        const updated = await result.json();
        const applied = updated.discount_codes?.some(item => item.code.toLowerCase() === code.toLowerCase() && item.applicable);
        status.textContent = [copied ? copy.dataset.copied : copy.dataset.copyFailed, applied ? copy.dataset.applied : copy.dataset.saved].join(' ');
      } catch { status.textContent = [copied ? copy.dataset.copied : copy.dataset.copyFailed, copy.dataset.failed].join(' '); }
      finally { label.textContent = original; copy.disabled = false; }
    });
    if (design) open(true);
    else if (session.shown || session.dismissed || root.dataset.auto !== 'true') revealTeaser();
    else timer = setInterval(() => { sampleTime(); if (session.elapsed >= delay) open(false); }, 500);
    promoCleanup = () => { clearInterval(timer); if (dialog.open) dialog.close(); controller.abort(); if (previousOverflow !== undefined) document.body.style.overflow = previousOverflow; };
  };

  const updateFloating = () => {
    const floating = document.querySelector('[data-bnh-floating]');
    const teaser = document.querySelector('[data-bnh-teaser]');
    const blocked = otherOverlay() || !!document.querySelector('.bnh-promo[open]');
    if (floating) floating.hidden = blocked;
    if (teaser) {
      if (blocked || session.checkout) teaser.hidden = true;
      else if (session.shown || session.dismissed || document.querySelector('[data-bnh-promo]')?.dataset.auto === 'false') teaser.hidden = false;
    }
    const stickyElement = document.querySelector('[data-sticky-atc]');
    const sticky = stickyElement && (stickyElement.classList.contains('is-visible') || getComputedStyle(stickyElement).visibility === 'visible') ? stickyElement : null;
    const height = sticky ? Math.max(20, sticky.getBoundingClientRect().height + (parseFloat(getComputedStyle(sticky).bottom) || 0) + 12) : 20;
    const bottom = `${Math.ceil(height)}px`;
    if (document.documentElement.style.getPropertyValue('--bnh-engagement-bottom') !== bottom) document.documentElement.style.setProperty('--bnh-engagement-bottom', bottom);
  };
  let floatingFrame;
  const scheduleFloating = () => {
    if (floatingFrame !== undefined) return;
    floatingFrame = requestAnimationFrame(() => { floatingFrame = undefined; updateFloating(); });
  };
  initProductLinks(document);
  initPromo();
  updateFloating();
  const floatingObserver = new MutationObserver(scheduleFloating);
  floatingObserver.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class', 'open', 'aria-hidden'] });
  window.addEventListener('resize', scheduleFloating, { passive: true });
  document.addEventListener('transitionend', event => { if (event.target.matches?.('[data-sticky-atc]')) updateFloating(); });
  document.addEventListener('binahad:cart-change', event => {
    cartHasItems = event.detail.itemCount > 0;
    if (cartHasItems) document.querySelector('.bnh-promo[open]')?.close();
    updateFloating();
  });
  document.addEventListener('shopify:section:load', event => { initProductLinks(event.target); initPromo(); updateFloating(); });
  document.addEventListener('shopify:section:unload', event => { if (event.target.querySelector('[data-bnh-promo]')) promoCleanup?.(); });
})();
